class SectionCollage extends HTMLElement {

  constructor() {
    super();

    var self = this;

    this.progress = this.querySelector('.progress');
    this.numSlides = this.querySelectorAll('.collage-item').length;

    var wrapper = this.querySelector('.collage-wrapper');
    var flkty = new Flickity(wrapper, {
      // options
      cellAlign: 'right',
      contain: true,
      cellSelector: '.collage-item',
      initialIndex: 1,
      prevNextButtons: false,
      pageDots: false,
    });
    flkty.on('change', function (index) {
      var width = 100 / self.numSlides * (index + 1);
      self.querySelector('.progress').style.width = width + '%';
    });
  }
}

customElements.define('section-collage', SectionCollage);